// extracted by mini-css-extract-plugin
export var alignBaseline = "_4-9";
export var alignCenter = "_4-5";
export var alignFlexEnd = "_4-7";
export var alignFlexStart = "_4-6";
export var alignSelfBaseline = "_4-e";
export var alignSelfCenter = "_4-a";
export var alignSelfFlexEnd = "_4-c";
export var alignSelfFlexStart = "_4-b";
export var alignSelfStretch = "_4-d";
export var alignStretch = "_4-8";
export var column = "_4-2";
export var columnReverse = "_4-4";
export var flex = "_4-0";
export var justifyCenter = "_4-f";
export var justifyFlexEnd = "_4-h";
export var justifyFlexStart = "_4-g";
export var justifySpaceAround = "_4-j";
export var justifySpaceBetween = "_4-i";
export var justifySpaceEvenly = "_4-k";
export var row = "_4-1";
export var rowReverse = "_4-3";
export var wrapNowrap = "_4-m";
export var wrapWrap = "_4-l";
export var wrapWrapReverse = "_4-n";